import Program from "./Program";
import SessionInvoice from "./SessionInvoice";
import { formatCurrency, formatDate } from "../utils/format-utils";
import { InvoiceBatchStatus } from "./InvoiceBatchStatus";

export default class InvoiceBatch {
  invoiceBatchId?: number;
  batchDate?: Date | null;
  programId?: number | null;
  program?: Program | null;
  batchNumber?: string | null;
  uploadedAt?: Date | null;
  invoiceNumber?: string | null;
  invoicedAt?: Date | null;
  voucherNumber?: string | null;
  certifiedAt?: Date | null;
  totalAmount?: number | null;
  sessionInvoices?: SessionInvoice[];
  paymentBatchId?: number | null;
  postedAt?: Date | null;

  public constructor(params: InvoiceBatch = {} as InvoiceBatch) {
    let {
      invoiceBatchId = 0,
      batchDate = null,
      programId = null,
      program = null,
      uploadedAt = null,
      batchNumber = "",
      invoicedAt = null,
      invoiceNumber = "",
      certifiedAt = null,
      voucherNumber = "",
      totalAmount = 0,
      sessionInvoices = [],
      paymentBatchId = null,
      postedAt = null,
    } = params;
    this.invoiceBatchId = invoiceBatchId;
    this.batchDate = batchDate;
    this.programId = programId;
    this.program = program && new Program(program);
    this.uploadedAt = uploadedAt;
    this.batchNumber = batchNumber;
    this.invoicedAt = invoicedAt;
    this.invoiceNumber = invoiceNumber;
    this.certifiedAt = certifiedAt;
    this.voucherNumber = voucherNumber;
    this.sessionInvoices =
      sessionInvoices && sessionInvoices.map((i) => new SessionInvoice(i));
    this.totalAmount = totalAmount;
    this.paymentBatchId = paymentBatchId;
    this.postedAt = postedAt;
  }

  get programName() {
    return this.program?.name;
  }

  get formattedBatchDate() {
    return formatDate(this.batchDate);
  }

  get formattedTotalAmount() {
    return formatCurrency(this.totalAmount);
  }

  get status() {
    if (Boolean(this.paymentBatchId) && Boolean(this.postedAt))
      return InvoiceBatchStatus.PAID;
    else if (Boolean(this.certifiedAt)) return InvoiceBatchStatus.APPROVED;
    else if (Boolean(this.invoicedAt)) return InvoiceBatchStatus.SUBMITTED;
    else if (Boolean(this.uploadedAt)) return InvoiceBatchStatus.UPLOADED;
    else return InvoiceBatchStatus.PENDING;
  }

  get statusColor() {
    switch (this.status) {
      case InvoiceBatchStatus.UPLOADED:
        return "accent";
      case InvoiceBatchStatus.SUBMITTED:
        return "secondary";
      case InvoiceBatchStatus.APPROVED:
        return "success";
      case InvoiceBatchStatus.PAID:
        return "primary";
      case InvoiceBatchStatus.PENDING:
      default:
        return "#808080";
    }
  }

  get invoiceErrorStatus() {
    return (
      Boolean(this.invoicedAt) &&
      this.sessionInvoices?.some((i) => !i.isInvoiced)
    );
  }
}
